/** KDS Menu — Kintsugi Design System node 1064:15007. */

/** Menu panel min width — 240px. */
export const menuContentMinWidth = '240px';

/** List item row min height — 40px. */
export const menuItemMinHeight = '40px';

/** Row and title corner radius — `radii.md` (6px). */
export const menuItemBorderRadius = 'md';

/** Leading/trailing icon box on menu items — 20px. */
export const menuItemIconSize = '20px';

/** Search leading icon — 16px. */
export const menuSearchIconSize = 16;

/** Search icon stroke — 2px. */
export const menuSearchIconStrokeWidth = 2;

/** Search icon + placeholder text. */
export const menuSearchIconColor = 'neutral.250';

/** Search input text. */
export const menuSearchTextColor = 'neutral.500';

/** Panel inset on sides, top (no search), and bottom — `lg` (16px). */
export const menuContentPaddingLg = '4';

/** Section title inset, item row inset, and vertical gaps — `sm` (8px). */
export const menuContentGapSm = '2';

/** Search row vertical inset — 12px (`spacing.3`). */
export const menuSearchPaddingY = '3';

/** Chakra `subtle` variant — KDS hover/selected colors replace Chakra defaults. */
export const menuVariant = 'subtle' as const;

/** Destructive menu item text — `red.700`. */
export const menuItemDestructiveColor = 'red.700' as const;

/** Destructive menu item highlight background — keep Red/50 (do not use brand.50). */
export const menuItemDestructiveHighlightedBg = 'red.50' as const;
